import { MutationCache } from '@tanstack/react-query';
import { toast } from 'sonner';

/**
 * What a save says when it lands: a fixed line ("Servicio guardado"), or one
 * built from what was sent and what came back. Only for results the person
 * can't already see in place: a drawer that closed, a link copied, a message
 * sent. A chip that changes on the screen speaks for itself.
 */
export type SuccessLine = string | ((variables: unknown, data: unknown) => string | null);

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: { exito?: SuccessLine };
  }
}

/** The line to show for a finished mutation, or null to stay quiet. */
export function successLine(line: SuccessLine | undefined, variables: unknown, data: unknown): string | null {
  const text = typeof line === 'function' ? line(variables, data) : line;
  return text && text.trim() ? text : null;
}

/** The mutation cache every QueryClient uses: a save with `meta.exito` confirms itself with one toast. */
export function feedbackMutationCache(show: (line: string) => unknown = toast.success): MutationCache {
  return new MutationCache({
    onSuccess: (data, variables, _context, mutation) => {
      const line = successLine(mutation.meta?.exito, variables, data);
      if (line) show(line);
    },
  });
}
